import { Languages } from '../../../../config';

const CONFIGURATION = {};

export default CONFIGURATION;

export const Translations = {
  add: {
    [Languages.Greek]: 'Add Payment',
    [Languages.English]: 'Add Payment',
  },
  amount_control: {
    [Languages.Greek]: 'Amount',
    [Languages.English]: 'Amount',
  },
  cents_control: {
    [Languages.Greek]: 'Cents',
    [Languages.English]: 'Cents',
  },
  payment_date_control: {
    [Languages.Greek]: 'Payment Date',
    [Languages.English]: 'Payment Date',
  },
  required_field: {
    [Languages.Greek]: 'Required Field',
    [Languages.English]: 'Required Field',
  },
  negative_amount_error: {
    [Languages.Greek]: 'The amount must be positive',
    [Languages.English]: 'The amount must be positive',
  },
  negative_cents_error: {
    [Languages.Greek]: 'Valid: 0-99',
    [Languages.English]: 'Valid: 0-99',
  },
  invalid_cents_error: {
    [Languages.Greek]: '1-2 digits',
    [Languages.English]: '1-2 digits',
  },
  invalid_amount_cents_error: {
    [Languages.Greek]: 'Valid: 0-99',
    [Languages.English]: 'Valid: 0-99',
  },
};
